/*
* OCR Verifier *
* Ip: Image, Verification Array
* Op:
* Author: @thinkdj
* Date: 23 July 2019
*/
import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { Observable, Observer } from 'rxjs';
import { HttpClient, HttpEvent, HttpEventType, HttpRequest, HttpResponse } from '@angular/common/http';
import { NzMessageService } from 'ng-zorro-antd/message';

@Component({
  selector: 'app-ocr-verifier',
  templateUrl: './ocr-verifier.component.html',
  styleUrls: ['./ocr-verifier.component.scss']
})
export class OcrVerifierComponent implements OnInit, OnDestroy {

  @Input() imageData:string = '';
  @Input() mode: 'auto'|'manual' = 'manual';
  @Input() verificationArr:Array<any> = [];

  @Output() verificationResult: EventEmitter<any> = new EventEmitter();
  //this.verificationResult.emit(data);

  isProcessing:boolean = false;
  hasProcessed: boolean = false;
  loading:boolean = false;

  apiKeyGoogVision: string = "AIzaSyAGQp130NDYtm-y0e3jG2hTrrgNQHj4Su8";
  apiEndPoint:string = "https://vision.googleapis.com/v1/images:annotate?key=";
  apiBody: any = {
    "requests":[
      {
        "image": { /* MUST have ONE of these sources , not all */
          "content": "----InsertBase64EncodedImage----",
          "source": {
            "imageUri": "----InsertExternalImageURL----",
            "gcsImageUri": "----InsertGCSImageURL----"
          }
        },
        "imageContext": {
          "webDetectionParams": {
            "includeGeoResults": true
          },
        },
        "features": [
          {
            "type": "LABEL_DETECTION",
            "maxResults": 10
          },
          {
            "type": "FACE_DETECTION",
            "maxResults": 5
          },
          {
            "type": "WEB_DETECTION",
            "maxResults": 10
          },
          {
            "type": "TEXT_DETECTION"
          },
          {
            "type": "DOCUMENT_TEXT_DETECTION"
          }
        ],
      },
    ]
  };

  constructor(
      private msg: NzMessageService,
      private http: HttpClient,
  ) { }

  ngOnInit() {

    /* Automatically make the API call ? */
    if(this.mode=='auto') this.makeVisionAPICall();

  }

  ngOnDestroy() {
  }

  setAPIbody() {

    this.apiBody.requests[0].image = {};

    if(this.imageData.startsWith("http")) { /* Passed Data is an http/https URL ? */
      this.apiBody.requests[0].image = {
        "source": {
          "imageUri": this.imageData
        }
      };
    }
    else if(this.imageData.startsWith("gs://")) { /* Google Cloud URL ? */
      this.apiBody.requests[0].image = {
        "source": {
          "gcsImageUri": this.imageData
        }
      };
    }
    else {  /* Else, it is image data string */
      if(this.imageData.includes("base64")) { /* If data passed has data:image/jpeg;base64, remove it */
        let base64 = String((this.imageData.split(","))[1]);
        // base64 = (String(this.imageData).split(" "))[0]; //to remove `(see http://g.co/ng/security#xss)` appended by DomSanitizer - NO!
        this.imageData = base64;
      }
      this.apiBody.requests[0].image = {
        "content": this.imageData
      };
    }
    console.log("API Body to be passed to Vision API", this.apiBody);

  }

  messageId: any = null;
  ocrResults: any = null;
  ocrCustomResults: any = null;
  verificationResultText:string = 'Processing';

  makeVisionAPICall() {

    this.messageId = this.msg.loading('Processing ...', { nzDuration: 0 }).messageId;
    this.isProcessing = true;
    this.verificationArr.forEach(i=>{i.status="Pending"});
    this.verificationArr.forEach(i=>{i.status="Processing"});

    this.setAPIbody();

    this.http.post(this.apiEndPoint+this.apiKeyGoogVision, this.apiBody)
        .subscribe( data => {

          this.isProcessing = false;
          this.msg.remove(this.messageId); /* Remove Message */

          let temp:any = data;
          this.ocrResults = temp.responses[0];
          this.ocrCustomResults = {
            'faces': this.ocrResults.faceAnnotations?this.ocrResults.faceAnnotations.length:0,
            'labels': this.ocrResults.labelAnnotations?this.ocrResults.labelAnnotations.map(item => {return item.description}):null,
            'guesses': this.ocrResults.webDetection.webEntities?this.ocrResults.webDetection.webEntities.map(item => {return item.description}):null,
            'text': this.ocrResults.textAnnotations?this.ocrResults.textAnnotations.map(item => {return item.description}):null,
          };

          let tempStr = String(this.ocrCustomResults.text[0]);
          this.ocrCustomResults.textLine = tempStr.replace(/\n/g,' ').replace(/\t/g,' ').replace(/\s{2,}/g, ' '); // All text in one line

          for(let i=0; i<this.verificationArr.length; i++) {
            if(this.ocrCustomResults.textLine.toLowerCase().includes(this.verificationArr[i].value.toLowerCase())){
              setTimeout(()=>this.verificationArr[i].status = "Passed",(i+1)*400);
            }
            else {
              setTimeout(()=>this.verificationArr[i].status = "Failed",(i+1)*400);
            }
            //Last pass
            if(i==(this.verificationArr.length-1)){
              setTimeout(()=>{
                let passed = this.verificationArr.filter(i=>i.status==="Passed").length;
                let failed = this.verificationArr.filter(i=>i.status==="Failed").length;
                let total = this.verificationArr.length;
                if(passed == total) this.verificationResultText = "Passed";
                if(failed == total) this.verificationResultText = "Failed";
                else if(failed > 0) this.verificationResultText = "Partially Passed";
                this.hasProcessed = true;
              }, Math.ceil((i+1.15)*400));
            }
          }


          this.ocrCustomResults.textCustom = this.ocrCustomResults.text[0].split('\n'); // All text

          this.ocrCustomResults.guesses.forEach( item=> {
            if("Permanent account number"==item) this.ocrCustomResults.documentBestGuess = "PAN Card";
            if("Passport"==item) this.ocrCustomResults.documentBestGuess = "Passport";
            if(!this.ocrCustomResults.documentBestGuess && "Driver's license"==item) this.ocrCustomResults.documentBestGuess = "Driving License";
            if("UIDAI"==item) this.ocrCustomResults.documentBestGuess = "Aadhar Card";
            if("Aadhar"==item) this.ocrCustomResults.documentBestGuess = "Aadhar Card";
          });


          this.ocrCustomResults.hasValidDocumentId = false;
          this.ocrCustomResults.textCustom.forEach( item=> {

            /* Indian Aadhar */
            if(/^\d{4}\s\d{4}\s\d{4}$/g.test(item)){
              this.ocrCustomResults.documentId = item;
              this.ocrCustomResults.hasValidDocumentId = true;
            }

            /* Remove whitespaces for further processing */
            item = item.replace(/\s/g,'');

            /* Indian PAN */
            if(/[A-Za-z]{5}\d{4}[A-Za-z]{1}/g.test(item)){
              this.ocrCustomResults.documentId = item;
              this.ocrCustomResults.hasValidDocumentId = true;
            }
            /* Indian Passport */
            if(/^[A-Z]{1}[0-9]{7}$/.test(item)){
              this.ocrCustomResults.documentId = item;
              this.ocrCustomResults.hasValidDocumentId = true;
            }

            /* Indonesian Driving License ID */
            if(!this.ocrCustomResults.hasValidDocumentId && /\d{8}/.test(item)){
              this.ocrCustomResults.documentId = item;
              this.ocrCustomResults.hasValidDocumentId = true;
            }

          });

          /* Guess Country of Issuance */
          this.ocrCustomResults.guesses.forEach( item=> {
            if(["India","Indonesia","USA","Canada","Singapore"].includes(item)){
              this.ocrCustomResults.documentCountry = item;
            }
          });
          if(!this.ocrCustomResults.documentCountry) {
            this.ocrCustomResults.text.forEach( item=> {
              item = item.toLowerCase().replace(/\b[a-z]/g, match => match.toUpperCase());
              if(["India","Indonesia","USA","Canada","Singapore"].includes(item)){
                this.ocrCustomResults.documentCountry = item;
              }
            })
          }

          /* Re check validity */
          this.ocrCustomResults.isValid = false;
          if(this.ocrCustomResults.hasValidDocumentId) {
            this.ocrCustomResults.isValid = true;
          }
          else if (this.ocrCustomResults.faces==1) this.ocrCustomResults.isValid = true;

        });
  }

}
